export default __webpack_public_path__ + "static/supportImg-bf776c26218955d72dc98caaf92f31d1.webp";